<template>
  <div id="app">
    <sui-container>
    <sui-menu v-if="signedIn">
        <sui-menu-item item simple> DataZone Industry</sui-menu-item>
        <router-link to="/" class="nav-link"><sui-menu-item item icon="home" simple></sui-menu-item></router-link>
        <sui-menu-item v-if="selectedClient"><router-link to="/device/list" class="nav-link">Devices</router-link></sui-menu-item>
        <sui-menu-item v-if="selectedClient"><router-link to="/channel/list" class="nav-link">Channels</router-link></sui-menu-item>
        <sui-menu-item v-if="selectedClient"><router-link to="/user/list" class="nav-link">Users</router-link></sui-menu-item>
        <sui-menu-item v-if="selectedClient"><router-link to="/api" class="nav-link">API</router-link></sui-menu-item>
        
        
        <sui-menu-menu position="right">
            <!--
                <sui-menu-item right>
                    <sui-input transparent icon="search" placeholder="Search..." />
                </sui-menu-item>
            -->
            <sui-menu-item item icon="group" simple right v-if="signedIn">
                <span v-if="selectedClient">{{ clientName }}</span>
                <span v-else>No selected client</span>
            </sui-menu-item>
            <sui-menu-item v-if="!signedIn"><router-link tag="p" to="/auth"><a>Sign Up / Sign In</a></router-link></sui-menu-item>
            <sui-menu-item v-if="signedIn"><a href="#" v-on:click="logout($event)">Logout</a></sui-menu-item>
            
          </sui-menu-menu>
      </sui-menu>
    
    
    <div v-if="error" class="ui negative message">
      <i class="close icon" v-on:click="removeError"></i>
      <div class="header">
        Error!
      </div>
      <ul v-if="multipleErrors">
          <li v-for="(e, index) in error" v-bind:key="index">{{ e }}</li>
      </ul>
      <p v-else>{{ error }}</p>
    </div>

    <router-view class="view"></router-view>
    </sui-container>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import { components } from 'aws-amplify-vue'
import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    ...components
  },
  data() {
    return {
      
    }
  },  
  computed: {
    selectedClient() {
        return this.signedIn && this.$store.state.clientId;
    },
    multipleErrors() {
      return this.error && typeof this.error !== 'string';
    },
    ...mapState([
      'error',
      'signedIn',
      'clientId',
      'clientName'
    ])
  },
  methods: {
        logout(e) {  
            e.preventDefault();    
            
            Auth.signOut()
            .then(() => {
              return AmplifyEventBus.$emit('authState', 'signedOut')
            })
            .catch(err => { this.$store.commit('setError', 'Error: ' + err); });
                
              
        },
        removeError() {
          this.$store.commit('setError', null);
        }
    },
  beforeCreate() {
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        //this.signedIn = true
        this.$store.commit('setSignedIn', true);
        if (this.$router.currentRoute!='/')
          this.$router.push('/')

        Auth.currentAuthenticatedUser().then(user => {
          this.$store.commit('setUserId', user.username);
        });
      }
      if (info === 'signedOut') {
        if (this.$router.currentRoute!='/')
          this.$router.push('/')
        //this.signedIn = false
        this.$store.commit('resetState');
      }
    });

    Auth.currentAuthenticatedUser()
      .then(() => {
        //this.signedIn = true
        this.$store.commit('setSignedIn', true);
      })
      .catch(() => {
        //this.signedIn = false
        this.$store.commit('resetState');
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
